import React, { createContext, useContext, useEffect, useState } from "react";
import { getLocalIP } from "../utils/getLocalIP";

const ALLOWED_IPS = [
  "185.154.239.218","185.154.239.219","185.154.239.220",
  "185.154.239.221","185.154.239.222",
  "194.153.203.210","194.153.203.211","194.153.203.212",
  "194.153.203.213","194.153.203.214",
  "109.168.92.18","109.168.92.19","109.168.92.20","109.168.92.21",
  "194.153.203.26","194.153.203.27","194.153.203.28","194.153.203.29","194.153.203.30",
];

const AuthContext = createContext(null);

/* =========================
   LOCAL STORAGE HELP
========================= */
const getStoredAuth = () => {
  try {
    return JSON.parse(localStorage.getItem("auth"));
  } catch {
    return null;
  }
};

export const AuthProvider = ({ children }) => {

  const [authState, setAuthState] = useState(
    getStoredAuth() || {
      checked: false,
      loggedIn: false,
      method: null,
      isGuestOnly: false,
    }
  );

  /* =========================
     PERSIST OGNI CAMBIO
  ========================= */
  useEffect(() => {
    localStorage.setItem("auth", JSON.stringify(authState));
  }, [authState]);

  /* =========================
     IP CHECK SOLO 1 VOLTA
  ========================= */
  useEffect(() => {
    const checkIP = async () => {
      const ip = await getLocalIP();
      const allowed = ip && ALLOWED_IPS.includes(ip);

      setAuthState((prev) => ({
        ...prev,
        checked: true,
        isGuestOnly: !allowed,
      }));
    };

    checkIP();
  }, []);

  /* =========================
     LOGIN PHP
  ========================= */
  const loginWithPassword = async (username, password) => {
    try {
      const res = await fetch(
        "https://dashboard.technoparts.it/ws/utenti_dashboard.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams({ username, password }),
        }
      );

      const data = await res.json();

      if (!data.ok) return { ok: false, error: data.error };

      const newState = {
        ...authState,
        loggedIn: true,
        method: "user",
      };

      setAuthState(newState);
      localStorage.setItem("auth", JSON.stringify(newState));

      return { ok: true };

    } catch {
      return { ok: false, error: "Errore server" };
    }
  };

  /* =========================
     GUEST
  ========================= */
  const loginGuest = () => {
    const newState = {
      ...authState,
      loggedIn: true,
      method: "guest",
    };

    setAuthState(newState);
    localStorage.setItem("auth", JSON.stringify(newState));

    return { ok: true };
  };

  /* =========================
     LOGOUT
  ========================= */
  const logout = () => {
    localStorage.removeItem("auth");

    setAuthState({
      checked: true,
      loggedIn: false,
      method: null,
      isGuestOnly: false,
    });
  };

  return (
    <AuthContext.Provider value={{
      ...authState,
      loginWithPassword,
      loginGuest,
      logout
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);